module.exports = __webpack_public_path__ + "static/media/attribute_melee_magic.acf52ee2.png";